import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Check if the error is related to MetaMask or Chrome Extensions
        const isMetaMaskError = error.message?.includes('MetaMask') ||
            error.stack?.includes('chrome-extension');

        if (isMetaMaskError) {
            console.warn('Caught external MetaMask error:', error);
            // We can choose to ignore this error state if we want to try rendering children anyway,
            // but usually getDerivedStateFromError has already set hasError=true.
            // For this specific case, we might want to just log it and not crash.
            return;
        }

        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="flex items-center justify-center h-screen bg-black text-white font-mono p-8 overflow-auto">
                    <div className="max-w-3xl text-center w-full">
                        <h1 className="text-2xl text-red-500 mb-4 tracking-widest border-b border-red-900 pb-4">SYSTEM MALFUNCTION</h1>
                        <p className="text-gray-400 mb-6 uppercase text-xs tracking-wider">Runtime Exception Detected</p>

                        <div className="bg-red-900/10 border border-red-900/30 p-4 rounded mb-6 text-left font-mono text-xs overflow-x-auto">
                            <p className="text-red-400 font-bold mb-2">{this.state.error && this.state.error.toString()}</p>
                            <pre className="text-red-300/50 whitespace-pre-wrap leading-relaxed">
                                {this.state.errorInfo && this.state.errorInfo.componentStack}
                            </pre>
                        </div>

                        <button
                            onClick={() => window.location.reload()}
                            className="px-6 py-2 bg-white text-black text-xs font-bold uppercase tracking-widest hover:bg-gray-200 transition-colors"
                        >
                            INITIATE REBOOT SEQUENCE
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
